/**
 * Escala de risco de crédito — score 90 (melhor) a 0 (pior).
 *
 * A cor aqui COMUNICA significado: verde = bom, vermelho = ruim. Por isso a escala não usa
 * a paleta de dataviz nem os tons de teal da marca — trocar o matiz destruiria a convenção
 * que o usuário já lê. O matiz decresce monotonicamente (147.9° verde → 3.2° vermelho).
 *
 * A escala anterior era gravemente inacessível: apenas 1 dos 10 níveis atingia WCAG AA
 * sobre fundo claro (os amarelos ficavam em 1.53:1). Esta atinge AA nos 10 níveis,
 * preservando a leitura verde→vermelho.
 *
 * Estrutura `{ key, value }` preservada da versão anterior — nenhum consumidor muda.
 * Contrastes medidos sobre --surface-canvas (#F7F9F8). Ver research.md (R5).
 */
export const colorsProgress = [
	{
		key: 90,
		value: '#1E834D', // 4.50:1
	},
	{
		key: 80,
		value: '#17851E', // 4.50:1
	},
	{
		key: 70,
		value: '#36820F', // 4.56:1
	},
	{
		key: 60,
		value: '#5F7C08', // 4.54:1
	},
	{
		key: 50,
		value: '#847103', // 4.57:1
	},
	{
		key: 40,
		value: '#905502', // 5.70:1
	},
	{
		key: 30,
		value: '#9A4A08', // 5.92:1
	},
	{
		key: 20,
		value: '#A33E0E', // 6.11:1
	},
	{
		key: 10,
		value: '#AC3216', // 6.16:1
	},
	{
		key: 0,
		value: '#B3261E', // 6.18:1
	},
];
